import { ItemType, Relationship } from '../types';
import getItemIdsByRank from './getItemsByRank';

export default function TextHierarchyDisplay({
  items,
  relationships,
}: {
  items: Record<string, ItemType>;
  relationships: Record<string, Relationship>;
}) {
  const { itemIds, cycleGroups } = getItemIdsByRank(relationships, items);

  return (
    <div className="p-3">
      {Object.entries(itemIds)
        .reverse()
        .map(([rank, items], index) => (
          <div key={rank} className="mb-3">
            <div className="text-muted mb-1">Rank {index + 1}</div>
            <div className="ms-3">
              {items.map((itemId) => (
                <div key={itemId}>{itemId}</div>
              ))}
            </div>
          </div>
        ))}
      {cycleGroups.length > 0 && (
        <div className="mt-4">
          <div className="text-warning mb-1">
            Items with Contradictory Relationships
          </div>
          <div className="ms-3">
            {cycleGroups.map((cycle, index) => (
              <div key={index} className="mb-2">
                {cycle.join(' ↔ ')}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
